import React from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

const useStyles = (makeStyles) => makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

function Notification(props) {
  const { Alert, Snackbar, makeStyles } = useUiContext();
  const { message, severity, opened } = props;

  const classes = useStyles(makeStyles);

  return (
    <div className={classes.root}>
      <Snackbar open={opened} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert variant="filled" severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  opened: PropTypes.bool.isRequired,
};

export default Notification;
